window.$ = window.jQuery = require('jquery');
global.moment = require('moment');
global.bsCustomFileInput = require('bs-custom-file-input');

require('bootstrap');
require('selectize');
require('tempusdominus-bootstrap-4');
